<!-- <div [class]="'app-header header-shadow ' + (config$ | async).headerTheme"
  style="background:linear-gradient(267deg, #0071bc, #000000)"> -->
<div [class]="'app-header header-shadow ' + (config$ | async).headerTheme"
  [ngClass]="{'scrolled': isScrolled}">
  <div class="container">
    <div class="app-header-panel">
      <div class="app-header-left">
        <div class="logo-src">
          <img [routerLink]="['/users-dashboard']"
            style="width: 100%; cursor: pointer;"
            src=".\assets\images\chettinad-link-logo - Copy - Copy.png" alt>
        </div>
        <!-- <app-search-box></app-search-box> -->
      </div>
      <div class="app-header__content">
        <div class="app-header-list">
          <div class="app-header-center">
            <ul>
              <li
                [routerLink]="['/users-dashboard']"
                routerLinkActive="active"
                (click)="closeMobileHeader()"
                [routerLinkActiveOptions]="{ exact: true }">
                Dashboard
              </li>
              <!-- <li
                [routerLink]="['/upgrade-plan']"
                routerLinkActive="active"
                (click)="closeMobileHeader()">
                Plans
              </li> -->
              <li
                [routerLink]="['/invoice-histroy']"
                routerLinkActive="active"
                (click)="closeMobileHeader()">
                History
              </li>
            </ul>
          </div>

          <div class="app-header-right">
            <app-user-box></app-user-box>
          </div>
        </div>
      </div>

      <!-- <div class="app-header__mobile-menu">
      <button type="button" class="hamburger close-sidebar-btn hamburger--elastic"
        [ngClass]="{'is-active' : globals.toggleSidebarMobile}" (click)="toggleSidebarMobile()">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
    </div> -->
      <div class="app-header__menu">
        <span>
          <button class="btn-icon btn-icon-only btn "
            style="background: linear-gradient(90deg, #0071bc, #33a1f2);"
            [ngClass]="{'is-active' : globals.toggleHeaderMobile}"
            (click)="toggleHeaderMobile()">
            <div class="btn-icon-wrapper">
              <fa-icon [icon]="faEllipsisV" class="text-white"></fa-icon>
            </div>
          </button>
        </span>
      </div>
    </div>

  </div>
</div>